export default {"src":"/practice/_next/static/media/varsity-tutors-logo.e52d0aff.svg","height":146,"width":879,"blurWidth":0,"blurHeight":0};